export default __webpack_public_path__ + "static/media/frutas_selecionadas.13591db5.png";